// eslint-disable-next-line no-unused-vars
import React from 'react';
import styled from '@emotion/styled';

const StyledImage = styled.div`
  width: 100%;
  box-sizing: border-box;

  .link {
    display: block;
  }

  .image {
    display: block;
    width: 100%;
    height: auto;
    object-fit: cover;
  }
`;

const Image = {
  label: 'Image',
  fields: {
    uploadedImageUrl: { type: 'text', label: 'Uploaded image URL' },
    imageUrl: { type: 'text', label: 'Image URL (fallback)' },
    imageAlt: { type: 'text', label: 'Image Alt' },
    linkUrl: { type: 'text', label: 'Link URL (optional)' },
    linkTarget: {
      type: 'radio',
      label: 'Link Target',
      options: [
        { label: 'Same tab', value: '_self' },
        { label: 'New tab', value: '_blank' },
      ],
    },
  },
  defaultProps: {
    uploadedImageUrl: '',
    imageUrl: 'https://picsum.photos/500/300',
    imageAlt: '',
    linkUrl: '',
    linkTarget: '_self',
  },
  render: ({ uploadedImageUrl, imageUrl, imageAlt, linkUrl, linkTarget }) => {
    const resolvedImageUrl = uploadedImageUrl || imageUrl;
    if (!resolvedImageUrl) return <></>;

    const image = (
      <img src={ resolvedImageUrl } alt={ imageAlt } className="image" />
    );

    return (
      <StyledImage>
        {linkUrl ? (
          <a
            href={ linkUrl }
            target={ linkTarget }
            rel={ linkTarget === '_blank' ? 'noopener noreferrer' : undefined }
            className="link"
          >
            {image}
          </a>
        ) : (
          image
        )}
      </StyledImage>
    );
  },
};

// eslint-disable-next-line import/prefer-default-export
export { Image };
